import React, { PureComponent } from 'react';
import Button from '../../components/button/button';

export default class EditablePanelComponent extends PureComponent {
  state = {
    editable: false
  };

  escFunction = event => {
    if (event.keyCode === 27) {
      this.cancelEdit();
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.saveForm();
  };

  saveForm = () => {
    if (this.state.editable) {
      // Save
      this.props.form.validateFields((errors, values) => {
        if (!errors) {
          Promise.resolve(this.sendSaveRequest(values)).then(() => {
            this.setState({ editable: false });
          });
        }
      });
    } else {
      this.setState({ editable: true });
    }
  };

  cancelEdit = () => {
    this.props.form.resetFields();
    this.setState({ editable: false });
  };

  sendSaveRequest = () => {
    console.error('saveForm method not implemented');
  };

  get editButtonsArray() {
    const { translate } = this.props;
    return <React.Fragment>
      {this.state.editable ? (
        <Button
          key={1}
          className={'cancel-edit'}
          active={false}
          onClick={this.cancelEdit}
        >
          {translate('profile.cancel')}
        </Button>
      ) : null}
      <Button key={2} onClick={this.saveForm}>
        {this.state.editable
          ? translate('profile.save')
          : translate('profile.edit')}
      </Button>
    </React.Fragment>;
  }

  get editButtons() {
    return <div className="edit-buttons">{this.editButtonsArray}</div>;
  }

  get editButtonsMobile() {
    return <div className="edit-buttons-mobile">{this.editButtonsArray}</div>;
  }
}
